import {JBoxDropDown} from 'Core/Components/JBoxDropdown/DropDown';
import {Modal} from 'Core/Common/Modal';
import {Event} from 'Core/Common/Event';
import {ZIndexManager} from 'Core/Common/ZIndexManager';
import {PUB_SUB_EVENTS} from 'MenuManager/PubSubEvents';
import {VueApp} from 'VueApp';

import {SubflowMonitorStore} from '../Stores/SubflowMonitorStore';
import {SubflowMonitorModel, SubflowMonitorRecordModel} from '../Models/Response/SubflowMonitorModel';

import SubflowMonitorList from 'Core/Components/ProgressBar/SubflowMonitor/SubflowMonitorList.vue';
import SubflowRecordsModal from 'Core/Components/ProgressBar/SubflowMonitor/SubflowRecordsModal.vue';

export interface ISubflowMonitorContext {
    EntityId: number;
    RecordId: number;
    LifeStatusId: number;
}

export class SubflowMonitor extends Event {
    private readonly _id: string;
    private _dropDown: JBoxDropDown;
    private _listEl: HTMLElement = null;
    private _recordsModal: Modal = null;
    private _recordsEl: HTMLElement = null;

    constructor(private _monitors: Array<SubflowMonitorModel>, private _context?: ISubflowMonitorContext) {
        super();
        this._id = JBoxDropDown.GetDropDownId();
    }

    Close() {
        if (this._dropDown) {
            this._dropDown.Close();
        }
    }

    Show(target: any) {
        this._listEl = document.createElement('div');

        VueApp.Mount(SubflowMonitorList, this._listEl, {
            groups: this._monitors || [],
            onShowRecords: (group: SubflowMonitorModel) => this.ShowRecords(group)
        });

        this._dropDown = new JBoxDropDown({
            target: target || '.' + this._id,
            otherOptions: {
                attach: undefined,
                closeOnClick: 'body',
                position: {
                    x: 'left',
                    y: 'bottom'
                },
                outside: 'y',
                pointer: 'left:20',
                onCloseComplete: () => {
                    VueApp.UnMount(this._listEl);
                    this._dropDown.Destroy();
                },
                zIndex: ZIndexManager.Instance.NextValue,
                addClass: 'lookup-dropdown js-subflow-monitor-dropdown',
                maxWidth: 'calc(100%)'
            },
            onOpen: () => {
                this._dropDown.SetContent({ content: this._listEl, isBindNeed: false });
            },
            bindComponent: this,
        });

        this._dropDown.Open();
    }

    private ShowRecords(group: SubflowMonitorModel) {
        this.Close();

        this._recordsEl = document.createElement('div');

        VueApp.Mount(SubflowRecordsModal, this._recordsEl, {
            title: group.TypeName || group.EntityName,
            completionLifeStatusName: group.CompletionLifeStatusName,
            entityId: group.EntityId,
            load: () => this.LoadRecords(group),
            onNavigate: (record: SubflowMonitorRecordModel, openInModal: boolean) =>
                this.GoToRecord(group, record, openInModal)
        });

        this._recordsModal = new Modal({ width: 460, maxHeight: 520, addClass: 'subflow-records-modal-wrapper' }, false);
        this._recordsModal.SetContent(this._recordsEl as any);
        this._recordsModal.Show();
    }

    private LoadRecords(group: SubflowMonitorModel): Promise<Array<SubflowMonitorRecordModel>> {
        if (!this._context) {
            return Promise.resolve([]);
        }

        const context = this._context;

        return new Promise((resolve, reject) => {
            SubflowMonitorStore.GetUnfinishedSubflowRecordsByGate({
                EntityId: context.EntityId,
                RecordId: context.RecordId,
                LifeStatusId: context.LifeStatusId,
                SubflowEntityId: group.EntityId,
                SubflowTypeId: group.TypeId
            })
                .then(records => resolve(records || []))
                .fail(error => reject(error));
        });
    }

    private GoToRecord(
        group: SubflowMonitorModel,
        record: SubflowMonitorRecordModel,
        openInModal: boolean = false
    ) {
        if (!record || !record.RecordId) {
            return;
        }

        if (!openInModal) {
            this.CloseRecords();
        }

        PubSub.publish(PUB_SUB_EVENTS.GO_TO_RECORD_SCREEN, {
            EntityId: group.EntityId,
            RecordId: record.RecordId,
            TypeId: group.TypeId,
            IsOpenInModal: openInModal
        });
    }

    private CloseRecords() {
        if (this._recordsEl) {
            VueApp.UnMount(this._recordsEl);
        }
        if (this._recordsModal) {
            this._recordsModal.Close();
        }
    }
}
